<dl cdkDropListGroup class="tabs contained">
  <dd cdkDropList [cdkDropListEnterPredicate]="enter" (cdkDropListDropped)="drop()" #placeholder></dd>
  @for (tElement of contentBlock.tabsBlock.elements | orderBy:'orderBy'; track tElement) {
    <dd cdkDropList (cdkDropListDropped)="drop()" [cdkDropListEnterPredicate]="enter" id="tab-{{tElement.id}}"
      [class.active]="tElement.isActive || (tElement.isActive == null && tElement.orderBy == 0)" class="tab-title"
      (click)="activateTabElement(tElement,true, tElement.id);$event.stopPropagation();"
      >
      <div [cdkDragDisabled]="!sortEnabled" cdkDrag class="tab-container">
        @if (tElement.assetId) {
          <img onerror="this.src = 'assets/img/loader.gif'"
            (load)="imageLoaded = true;" [hidden]="!imageLoaded" loading="lazy"
            [src]="getTabImage(tElement) | loadSecureAssets : true | async" class="tab-img" />
        }
        <div id="simpleTab{{tElement.id}}" style="position: relative;display:inline-block;"
          [ngClass]="{handleTab: sortEnabled}" [hidden]="(tElement.id !== currentEditTab) || tElement.assetId">
          <div #editor id="simpleTab-editor-{{tElement.id}}" contenteditable="true" class="tab-title-text" appCKEditor
            (ckBlur)="updateTabElement($event,tElement)" [innerHTML]="tElement.title"
            [inlineMenuId]="'tab-menu-' + tElement.id">
          </div>
        </div>
        <a id="edit-tab-{{tElement.id}}">
          @if ((tElement.title != '') && (tElement.id != currentEditTab) && (tElement.assetId == null)) {
            <div [innerHTML]="tElement.title" class="tab-title-text"
              >
            </div>
          }
          <i [hidden]="sortEnabled" (click)="openEditor(tElement,editor);$event.stopPropagation();"
          class="material-icons ms-2 edit-tab-icon">create</i>
        </a>
      </div>
    </dd>
  }

  <dd id="tab-0" class="add-new tab-button cdk-drag-disabled">
    <a href="javascript:void(0);" (click)="addTabElement()" class="add-button">
      <i class="material-icons edit-tab-icon">add_circle_outline</i>
    </a>
  </dd>

  <dd id="tab-0" class="ms-auto remove-tab tab-button cdk-drag-disabled">
    <a href="javascript:void(0);" (click)="toggleSorting();$event.stopPropagation();"><i
    class="material-icons edit-tab-icon">open_with</i></a>
  </dd>
</dl>
<ul class="tabsContent contained" id="{{contentBlock.tabsBlock.elements[0]?.tabsBlockId}}">
  @for (tElement of contentBlock.tabsBlock.elements; track tElement) {
    <li class="simple-tab-content" [ngClass]="{active: tabIsActive(tElement)}" [hidden]="!tabIsActive(tElement)"
      id="{{tElement?.id}}">
      @if (tElement && tElement.isActive && tElement.container) {
        <div class="tab-parent-div">
          @for (column of tElement.container.contentColumns | orderBy:'order'; track column) {
            <app-content-box [hidden]="column.isDeleted" [contentColumn]="column" [parentSectionId]="parentSectionId"
              [level]="level + 1" [container]="container" [tElement]="{t: tElement, c:contentBlock}"
              [reorderContent]="reorderContent" [hideContent]="hideContent"
              class="custom-col col grid-{{column.columnWidth}} tab-container" id="column-{{column.id}}"
              [pageTemplateId]="pageTemplateId">
            </app-content-box>
          }
        </div>
      }
      <div class="clear"></div>
    </li>
  }
</ul>